module.exports = __webpack_public_path__ + "static/media/exhsmall4.39f36981.png";